module.exports = __webpack_public_path__ + "static/slider-img-two-592d610b04a2e72d2b1a332672d50d8b.jpg";